import { BaseApiService } from '@/shared/api/services/base.service';
import { buildUrl } from '@/shared/lib/query-params';
import type {
  PaymentListResponse,
  PaymentGatewayResponse,
  Payment,
} from '@/types/payment';

interface PaymentListParams {
  page?: number;
  include?: string[];
  sort?: string[];
  filter?: {
    type?: string;
    status?: string;
    date_from?: string;
    date_to?: string;
  };
}

class PaymentsService extends BaseApiService {
  async getPayments(params?: PaymentListParams): Promise<PaymentListResponse> {
    const url = buildUrl('/v1/payments', {
      page: params?.page ? { number: params.page } : undefined,
      include: params?.include,
      sort: params?.sort,
      filter: params?.filter,
    });
    return this.httpGet<PaymentListResponse>(url);
  }

  async getPayment(paymentId: string): Promise<{ data: Payment }> {
    return this.httpGet<{ data: Payment }>(`/v1/payments/${paymentId}`);
  }

  async getPaymentGateways(currency?: string): Promise<PaymentGatewayResponse> {
    const url = currency
      ? `/v1/payments/gateways?currency=${currency}`
      : '/v1/payments/gateways';
    return this.httpGet<PaymentGatewayResponse>(url);
  }

  async downloadReceipt(paymentId: string): Promise<string> {
    const response = await this.post<{ data: { url: string } }>(
      `/v1/payments/${paymentId}/receipt`
    );
    return response.data.url;
  }

  async emailReceipt(paymentId: string, email: string): Promise<void> {
    await this.post(
      `/v1/payments/${paymentId}/email-receipt`,
      this.formatJsonApiData('receipt', { email })
    );
  }
}

export const paymentsService = new PaymentsService();
